import script from "./CustomerOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerOrders.vue?vue&type=script&setup=true&lang=js"

import "./CustomerOrders.vue?vue&type=style&index=0&id=856c8848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-856c8848"]])

export default __exports__